import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import type { BizySourceDetailsNode } from '../../types/nodes';
import { BizyAnalyticsEvent, useBizyAnalytics } from '../context/analytics-context';
import { BIZY_KIT_I18N_NAMESPACE } from '../i18n';
import type { BizyNodeProps } from './node-props';

/**
 * Renders the Data Agent's SourceDetails node — the collapsible "How I got
 * this" provenance panel that trails a data answer. Collapsed by default.
 */
export function SourceDetailsNode({ node }: BizyNodeProps) {
	const { sourceDetails, caveats } = (node as BizySourceDetailsNode).payload;
	const { t } = useTranslation(BIZY_KIT_I18N_NAMESPACE);
	const { track, conversationId, messageId } = useBizyAnalytics();

	const handleToggle = (e: React.SyntheticEvent<HTMLElement>) => {
		const open = (e.currentTarget as HTMLDetailsElement).open;
		track(BizyAnalyticsEvent.SourceDetailsToggled, { open, conversationId, messageId, path: window.location.pathname });
	};

	return (
		<Box as="details" mb={4} fontSize="sm" color="text.muted" data-testid="bizy-source-details" onToggle={handleToggle}>
			<Box as="summary" cursor="pointer" fontSize="sm" fontWeight="semibold" color="text.default">
				{t('sourceDetails.heading')}
			</Box>
			<Box mt={2}>
				<Text fontSize="sm" fontWeight="semibold" color="text.default">
					{t('sourceDetails.sourceDetailsLabel')}
				</Text>
				<Text fontSize="sm" mb={2}>
					{sourceDetails || t('sourceDetails.noSourceDetails')}
				</Text>
				<Text fontSize="sm" fontWeight="semibold" color="text.default">
					{t('sourceDetails.caveatsLabel')}
				</Text>
				<Text fontSize="sm">{caveats || t('sourceDetails.noCaveats')}</Text>
			</Box>
		</Box>
	);
}
